import {
    KIOSK_VISITORS_REQUESTED,
    KIOSK_VISITORS_SUCCESS,
    KIOSK_VISITORS_FAILED,
    ADD_KIOSK_VISITOR_REQUESTED,
    ADD_KIOSK_VISITOR_SUCCESS,
    ADD_KIOSK_VISITOR_FAILED,
    VALIDATE_KIOSK_VISITOR_REQUESTED,
    VALIDATE_KIOSK_VISITOR_SUCCESS,
    VALIDATE_KIOSK_VISITOR_FAILED,
} from './constants';
import { Action } from '../useReducerWithMiddleware';
import { Visitor } from 'types/Visitor';

export type VisitorKioskState = {
    loading: boolean;
    errorMessage: string;
    successMessage: string;
    kioskVisitors: Visitor[] | null;
};

export const initialVisitorKioskState: VisitorKioskState = {
    loading: false,
    errorMessage: '',
    successMessage: '',
    kioskVisitors: null,
};

export default function visitorKioskReducer(
    state: VisitorKioskState = initialVisitorKioskState,
    action: Action
): VisitorKioskState {
    switch (action.type) {
        case KIOSK_VISITORS_REQUESTED:
        case ADD_KIOSK_VISITOR_REQUESTED:
        case VALIDATE_KIOSK_VISITOR_REQUESTED:
            return {
                ...state,
                errorMessage: '',
                successMessage: '',
                loading: true,
            };
        case KIOSK_VISITORS_SUCCESS:
            return {
                ...state,
                loading: false,
                kioskVisitors: (action.payload as { visitors: Visitor[] }).visitors,
            };
        case KIOSK_VISITORS_FAILED:
        case ADD_KIOSK_VISITOR_FAILED:
        case VALIDATE_KIOSK_VISITOR_FAILED:
            return {
                ...state,
                errorMessage: (action.payload as { message: string }).message,
                loading: false,
            };
        case ADD_KIOSK_VISITOR_SUCCESS:
        case VALIDATE_KIOSK_VISITOR_SUCCESS:
            return {
                ...state,
                successMessage: (action.payload as { message: string }).message,
                kioskVisitors: (action.payload as { visitors: Visitor[] }).visitors,
                loading: false,
            };
        default:
            return state || initialVisitorKioskState;
    }
}
